import NodataAvailable from "../../../../assets/images/NodataAvailable.svg";
import {
  setBenPayoutOtp,
  setCurrentSteps,
  setPayoutClick,
  setRefId,
  setSelectedBeneficiary,
  setTableClick,
} from "../bloc/beneficiariesSlice";
import copyIcon from "../../../../assets/images/copy.svg";
import { copyText } from "../../../../helpers/payouts";
import { Button, PanelSlider } from "../../../../components/ui";
import { ArrowForwardIos, Label } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../../store";
import PayoutsData from "../payout/payouts-data";
import cancelIcon from "../../../../assets/images/close.svg";
import SelectedBeneficiary from "../getDetailsById/selectedBeneficiary";
import Steps from "../../../../components/steps";
import { resetPayouts } from "../payout/payoutSlice";
import UserAccountStatusString from "../../../customer/CustomerDetails/status-string";
import { getMarketStatusDisplayIcon } from "../../../../helpers/getText";
import LoadingDiv from "../../../customersV2/loader";
import classes from "./style.module.scss";

const headers = [
  { label: "#", width: "50px" },
  { label: "Fund Account ID", width: "220px" },
  { label: "Beneficiary Name", width: "200px" },
  { label: "Account Number", width: "150px" },
  { label: "Bank Name", width: "180px" },
  { label: "IFSC", width: "150px" },
  { label: "Mobile Number", width: "150px" },
  { label: "Email", width: "200px" },
  { label: "Status", width: "250px" },
];

const BeneficiaryTable = () => {
  const dispatch = useDispatch();

  const {
    isLoading,
    payoutClick,
    tableClick,
    selectedBeneficiary,
    currentSteps,
    filterData,
    roleType
  } = useSelector((state: TRootState) => ({
    isLoading: state.beneficiary.isLoading,
    payoutClick: state.beneficiary.payoutClick,
    tableClick: state.beneficiary.tableClick,
    selectedBeneficiary: state.beneficiary.selectedBeneficiary,
    currentSteps: state.beneficiary.currentSteps,
    filterData: state.beneficiary.filterData,
    roleType: state.auth.userInfo.roleType
  }));

  return (
    <>
      <div className="">
        <div
          className={`${classes.tablewrapper} bg-white mt-4`}
          style={{
            height: "calc(100vh - 22rem)",
          }}
          id="scroll_style"
        >
          <div className={`${classes.tablecontainer_mos}`}>
            <table
              border={1}
              style={{ width: "100%", borderCollapse: "collapse" }}
              className="customers_table"
            >
              <thead>
                <tr>
                  {headers.map((item, index) => (
                    <th
                      key={index}
                      className={`p-3 bg-oceangreen color-text-primary ${index !== headers.length - 1 ? "border-r" : ""
                        } `}
                      style={{
                        width: item.width,
                        minWidth: item.width,
                      }}
                    >
                      {item.label}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={8} className="py-8">
                      <div className="flex items-center justify-center h-full">
                        <LoadingDiv />
                      </div>
                    </td>
                  </tr>
                ) : filterData?.length > 0 ? (
                  filterData.map((item, i) => (
                    <tr
                      className="border-b cursor-pointer"
                      onClick={() => {
                        dispatch(setTableClick(true));
                        dispatch(setSelectedBeneficiary(item));
                        dispatch(setBenPayoutOtp(0));
                        dispatch(setRefId(""));
                      }}
                    >
                      <td className="px-3 py-2">{i + 1}</td>
                      <td className="px-3 py-2 ">
                        <div className="  border-r  flex items-center justify-between">
                          {item?.rzpFa}
                          <img
                            src={copyIcon}
                            className="cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              copyText(item?.rzpFa);
                            }}
                            style={{ width: "25px" }}
                          />
                        </div>
                      </td>
                      <td className="px-3 py-2">{item?.actHolder}</td>
                      <td className="px-3 py-2">{item?.actNum}</td>

                      <td className="px-3 py-2"> {item?.bank}</td>

                      <td className="px-3 py-2">{item?.ifsc}</td>

                      <td className="px-3 py-2 ">{item?.mobile}</td>

                      <td className="px-3 py-2 ">{item?.email}</td>

                      <td className="px-3 py-2 ">
                        <div className=" flex items-center justify-between">
                          <span
                            className={`font-medium ${item?.status === 1
                                ? "color-primary"
                                : "color-orange"
                              }`}
                          >
                            <UserAccountStatusString
                              statusIcon={getMarketStatusDisplayIcon({
                                status:
                                  item?.status === 1 ? "ACTIVE" : "INACTIVE",
                              })}
                              isIconNeed={false}
                            />
                          </span>

                          <div
                            className="flex items-center gap-2"
                          >
                            {item?.status === 1 && (roleType === 'ADMIN' || roleType === 'MANAGER') && (
                              <div onClick={(e) => e.stopPropagation()}>
                              <Button
                                variant="outlined-primary"
                                onClick={() => {
                                  dispatch(setSelectedBeneficiary(item));
                                  dispatch(setCurrentSteps(1));
                                  dispatch(resetPayouts());
                                  dispatch(setTableClick(false));
                                  dispatch(setPayoutClick(true));
                                  dispatch(setBenPayoutOtp(0));
                                  dispatch(setRefId(""));
                                }}
                              >
                                Payout
                              </Button>
                              </div>
                            )}

                            <div className="br-100 icon_bg w-[25px] h-[25px] flex items-center justify-center color-inactive">
                              <ArrowForwardIos
                                style={{
                                  fontSize: 14,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="py-8">
                      <div className="flex items-center justify-center h-full">
                        <img src={NodataAvailable} alt="No data available" />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {payoutClick && (
        <PanelSlider
          direction="right_to_left"
          open={payoutClick}
          onClose={() => {
            dispatch(setPayoutClick(false));
          }}
          style={{ width: "40vw" }}
        >
          <div
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            className="panel-content"
          >
            <div className="border-b card_space_18 flex items-center justify-between">
              <div>
                <h2 className="fs-14 font-bold">Payout</h2>
              </div>
              <div>
                <Steps stepCount={2} currentStep={currentSteps} />
              </div>
              <div>
                <img
                  src={cancelIcon}
                  alt=""
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch(setPayoutClick(false));
                  }}
                />
              </div>
            </div>

            <PayoutsData />
          </div>
        </PanelSlider>
      )}

      {tableClick && (
        <PanelSlider
          direction="right_to_left"
          open={tableClick}
          onClose={() => {
            dispatch(setTableClick(false));
          }}
          style={{ width: "40vw" }}
        >
          <div
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            className="panel-content"
          >
            <div className="border-b card_space_18  flex items-center justify-between">
              <div>
                <h2 className="fs-14 font-bold">
                  {selectedBeneficiary?.actHolder}
                </h2>
              </div>
              <div>
                <img
                  src={cancelIcon}
                  alt=""
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch(setTableClick(false));
                  }}
                />
              </div>
            </div>

            <div className="bg-gray-bg">
              <SelectedBeneficiary />
            </div>
          </div>
        </PanelSlider>
      )}
    </>
  );
};

export default BeneficiaryTable;
